'use strict';
import Config from '../Config';
import {getItemWithExpiry,setItemWithExpiry} from '../utilities/localStorageUtils';

const Affiliate = {

    setAffiliate(){
        
        const query = new URLSearchParams(window.location.search);
        const code = query.get('dealerCode');
        const url = query.get('url');
            
        if (code != undefined && code != null && url != undefined && url != null) {        
            
            let item = getItemWithExpiry("dealerCode") ;

            if(item == undefined){         
                setItemWithExpiry("dealerCode",code,Config.affiliateExpiryTimeInDays);
            }
        
            window.location.replace(Config.staticWebSiteUrl + '/' + url.toLowerCase());
        }       
    }
};


  export default Affiliate